import { useEffect } from "react";
import { useUser } from "./useUser";


const SURVICATE_ID = import.meta.env.VITE_SURVICATE_ID;
export default function useSurvicate() {
    const {data: user} = useUser()
    useEffect(() => {
        async function start() {
            if (user) {
                try {
                    await insertSurvicateScript()
                    setSurvicateAttributes(user.id)
                } catch(_e) { }
            }
        }
        start()
    },[user])

}

function setSurvicateAttributes(userId: string) {
    if (!window.dmf_didSetSurvicateAttributes) {
        function surveycateReady() {
            window._sva.setVisitorTraits({
                user_id: userId,
                // has_responded: window.localStorage.getItem("dmf_has_responded_to_survicate") === "true"
            });
            // window._sva.addEventListener("survey_completed", function() {
            //     window._sva.setVisitorTraits({
            //         has_responded: true
            //     });
            //     window.localStorage.setItem("dmf_has_responded_to_survicate", "true")
            // })        
        }
        if (window._sva) {
            surveycateReady();
        } else {
            window.addEventListener("SurvicateReady", surveycateReady);
        }
        window.dmf_didSetSurvicateAttributes = true
    }
}
function insertSurvicateScript() {
    return new Promise((resolve, reject) => {
        if (document.getElementById(SURVICATE_ID)) return reject("No survicate id");
        const script = document.createElement('script');
        script.src = 'https://survey.survicate.com/workspaces/'+SURVICATE_ID+'/web_surveys.js';
        script.id = SURVICATE_ID
        script.async = true;
        document.head.insertAdjacentElement("afterbegin", script)
        script.onload = function(e) {
            // @ts-ignore
            window._svd.permissions =  {
                "targeting_javascript_api": true,
                "web_surveys_npm_package": true,
                "surveys_screenshots": false
            };
            resolve(e)
        }
    })
}

// export async function forceShowSurvey() {
//     window._sva.destroyVisitor()
// }
// export async function showSurvey(userId?: string) {
//     const custom_surveycate_event_name = "dmf_display_survey"
//     try {
//         if (window._sva && window._sva.destroyVisitor && window._sva.invokeEvent) {
//             await window._sva.destroyVisitor()
//             if (window._sva && window._sva.setVisitorTraits && userId) {
//                 window._sva.setVisitorTraits({
//                     user_id: userId
//                 });
//             }
//             window._sva.invokeEvent(custom_surveycate_event_name)
//         } else {
//             throw new Error("Survicate not ready")
//         }
//     } catch(e) {
//         captureException(e)
//     }
// }